import React, { Component } from 'react';
import {
    Form,
    Select,
    TreeSelect,
    InputNumber,
    Modal,
    Radio,
    message,
    Button,
    Upload,
    Icon,
    Rate,
    Checkbox,
    Row,
    Col,
    Drawer,
    Layout,
    Cascader,
    Input,
    Card
} from 'antd';
import subapi from '../subapi';
const { TreeNode } = TreeSelect;
const { Content } = Layout;
const { TextArea } = Input;
const { SHOW_PARENT } = TreeSelect;
const { Option } = Select;
const FormItem = Form.Item;


class EditVersion extends Component {
    constructor(props) {
        super(props)
        console.log(this.props)
        this.state = {
            divisionFocus: true,
            versionjudgement: true,
            versionjudg: true,
            gray: 0, //灰度范围判断
            phoneNumber: true,
            lessee: [],
            treeData: [],
            framework: [],
        }
    }
    componentDidMount() {
        //this.versionDetails();
        this.tenantSearch();
        this.architectureSearch();
        // let params = {
        //     access_token: token,
        //     id: this.props.editorialContent
        // }
        // await subapi.versionDetails(params).then(res => {
        //     this.setState({ version: res.content })
        // })
        // this.graylLevelJudgement(this.state.version.scale_content)

    //    setTimeout(() => {
    //        console.log(this.props.editorialContent.scale_content)
    //     this.lease(this.props.editorialContent.scale_content)
    //    }, 200);
    
    
    }
    //搜索组织架构
    tree_search=e=>{
        console.log(e);
        var _this=this;
        let token = sessionStorage.getItem('access_token');
        let params = {
            access_token: token,
            name:e
        };
        subapi.architectureSearch(params).then(function (data) {
            if (data.code === 0) {
                //treeNode.props.dataRef.children = data.content
                // _this.setState({
                //     framework:data.content
                // });
                _this.setState({ framework: data.content })
            } else {
                message.error(data.message);
            }
        })
    }
    //获取租户搜索
    tenantSearch() {
        let token = sessionStorage.getItem('access_token');
        let params = {
            access_token: token,
        };
        subapi.tenantSearch(params).then(res => {
            console.log(res)
            this.setState({ lessee: res.content })
        })
    }
    //获取组织架构搜索
    architectureSearch() {
        let token = sessionStorage.getItem('access_token');
        let params = {
            access_token: token,
        };
        subapi.architectureSearch(params).then(res => {
            this.setState({ framework: res.content })
        })
    }
    divisionFocus = () => {
        this.setState({ divisionFocus: false })
    }
    mold = (data) => {
        let mold = [];
        if (data.app === "cgj" && data.type === 1) {
            mold.push("彩管家","Android")
        } else if (data.app === "cgj" && data.type === 2) {
            mold.push("彩管家","ios")
        } else if (data.app === "czy" && data.type === 2) {
            mold.push("彩之云","ios")
        } else if (data.app === "czy" && data.type === 1) {
            mold.push("彩之云","Android")
        }else if (data.app === "wyt" && data.type === 2) {
            mold.push("物业通","ios")
        } else if (data.app === "wyt" && data.type === 1) {
            mold.push("物业通","Android")
        }
        return mold
    }
    inputOnBlurStaff = ({ target: { value } }) => {
        var select_val=this.props.form.getFieldsValue().select||[];
        if(select_val[0]==='彩之云'){
            var patt1 = new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){3}$/);
            var patt2= new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/);
           // console.log(patt1.test(value))
            if (patt1.test(value)||patt2.test(value)) {
                this.setState({ versionjudgement: true })
            } else {
                this.setState({ versionjudgement: false })
            }
        }else{
            var patt1 = new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/);
            if (patt1.test(value)) {
                this.setState({ versionjudgement: true })
            } else {
                this.setState({ versionjudgement: false })
            }
        }
    }
    //判断支持最低版本号
    versionOnBlurStaff = ({ target: { value } }) => {
        var select_val=this.props.form.getFieldsValue().select||[];
        if(select_val[0]==='彩之云'){
            var patt1 = new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){3}$/);
            var patt2= new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/);
            //console.log(patt1.test(value))
            if (patt1.test(value)||patt2.test(value)) {
                this.setState({ versionjudg: true })
            } else {
                this.setState({ versionjudg: false })
            }
        }else{
            var patt1 = new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/);
            if (patt1.test(value)) {
                this.setState({ versionjudg: true })
            } else {
                this.setState({ versionjudg: false })
            }
        }
    }
    //灰度范围
    tonalOnChange = ({ target: { value } }) => {
        //console.log(value)
        // if (value === 1) {
        //     this.setState({ gray: 1 })
        // } else if (value === 2) {
        //     this.setState({ gray: 2 })
        // }
        this.setState({ gray: value })
    }
    PhoneNumber(number=[],organization=[],tenant=[]){
        //console.log(number,organization,tenant)
        let scale_content=[]
        number.map(item=>{
            scale_content.push({
                "type":"1",
                "detail":item,
                "name":item
            })
        })
        organization.map(item=>{
            //console.log(item)
            scale_content.push({
                "type":"2",
                "detail":item[1],
                "name":item[0]
            })
        })
        tenant.map(item=>{
            //console.log(item)
            scale_content.push({
                "type":"3",
                "detail":item[0],
                "name":item[1]
            })
        })
        //console.log(JSON.stringify(scale_content))
        return JSON.stringify(scale_content);
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            console.log(values)
            console.log(this.props.editorialContent)
            let app = "";
            let type = "";
            if (values.select) {
                if (values.select[0] === '彩管家' && values.select[1] == 'Android') {
                    app = "cgj"; type = '1'
                } else if (values.select[0] === '彩之云' && values.select[1] == 'ios') {
                    app = 'czy'; type = '2';
                } else if (values.select[0] === '彩管家' && values.select[1] == 'ios') {
                    app = "cgj"; type = '2'
                } else if (values.select[0] === '彩之云' && values.select[1] == 'Android') {
                    app = "czy"; type = '1'
                }else if(values.select[0] === '物业通' && values.select[1] == 'Android'){
                    app='wyt';type='1';
                } else if(values.select[0] === '物业通' && values.select[1] == 'ios'){
                    app='wyt';type='2';
                }
            }
            if(!err){
                let token = sessionStorage.getItem('access_token');
                let param = {
                    id:this.props.id,
                    access_token: token,
                    file_id:this.props.editorialContent.file_id
                }
                for (let item in values) {
                    if (values[item]) {
                        switch (item) {
                            case 'select':
                                param['app'] = app;
                                param['type'] = type;
                                break;
                            case 'input-number':
                                param['version'] = values[item];
                                break;
                            case 'version-number':
                                param['min_version'] = values[item];
                                break;
                            case 'restoredBug':
                                param['bug'] = values[item];
                                break;
                            case 'contents':
                                param['func'] = values[item];
                                break;
                            case 'phone':
                                param['scale_content'] = this.state.gray == 1 ?"":this.PhoneNumber(values.phone,values.organization,values.tenant);
                                break;
                            case 'organization':
                                param['scale_content'] = this.state.gray == 1 ?"":this.PhoneNumber(values.phone,values.organization,values.tenant);
                                break;
                            case 'tenant':
                                param['scale_content'] = this.state.gray == 1 ?"":this.PhoneNumber(values.phone,values.organization,values.tenant);
                                break;
                        }
                    }
                }
                console.log(param)
                if(this.state.versionjudgement && this.state.versionjudg && this.state.phoneNumber){
                    subapi.compiler(param).then(res=>{
                        if(res.code === 0){
                            message.success('编辑成功');
                            setTimeout(()=>{
                            window.location.reload();
                            },500)
                        }else{
                            message.error('编辑失败');
                        }
                    })
                }
            }
            
        })
    }
    onInputKeyDown = (value) => {
        //console.log(value)
        if (!/^([，；,;]*1\d{10}[，；,;]*)*$/.test(value.join(','))) {
            this.setState({ phoneNumber: false })
        } else {
            this.setState({ phoneNumber: true })
        }
        //this.setState({scale_content:value.join(",")})

    }
    phones = (data) => {
        if (data) {
            let dataArray = eval("(" + data + ")");
            let phone = [];
            let structure = [];
            let tenant = [];
            dataArray.map(item => {
                if (item.type == 1) {
                    phone.push(item.name)
                } else if (item.type == 2) {
                    structure.push(item.name)
                } else if (item.type == 3) {
                    tenant.push(item.name)
                }
            })
            return phone
            //this.setState({phone,structure,tenant})
        }
    }
    organizational = (data) => {
        if (data) {
            let dataArray = eval("(" + data + ")");
            let structure = [];
            dataArray.map(item => {
                if (item.type == 2) {
                    structure.push([item.name,item.detail])
                }
            })
            //console.log(structure)
            return structure
        }
    }
    lease = (data) => {
        //console.log(data)
        if (data) {
            let dataArray = eval("(" + data + ")");
            let tenant = [];
            dataArray.map(item => {
               // console.log(item)
                if (item.type == 3) {
                    tenant.push([item.detail,item.name])
                }
            })
            //console.log(tenant)
           //this.setState({value:tenant})
            return tenant
        }
    }
    //租户
    // leaseholder = (data) =>
    //     data.map(item => {
    //         return <TreeNode title={item.corpName} value={[item.corpUuid, item.corpName]} key={item.id} dataRef={item} />;
    //     })
    combine = (data) => {
        //console.log(data)
        let result = [];
        data.map((item, i) => {
            result.push({
                key: item.id,
                value: [item.corpUuid,item.corpName],
                title: item.corpName,
            });
        });
        return result;
    }
    onLoadData = (treeNode) => {
        let _this = this;
        //console.log(treeNode.props)
        return new Promise((resolve) => {
            if (!treeNode.props.children || !treeNode.props.children.length) {
                let token = sessionStorage.getItem('access_token');
                let params = {
                    access_token: token,
                    org_uuid: treeNode.props.dataRef.orgUuid
                };
                subapi.architectureSearch(params).then(function (data) {
                    if (data.code === 0) {
                        treeNode.props.dataRef.children = data.content
                        _this.setState({
                            treeData: [..._this.state.treeData],
                        });
                    } else {
                        message.error(data.message);
                    }
                })
            }
            resolve();
        });
    }
    renderTreeNodes = data => {
        //console.log(data)
        let rahmen;
        if (data) {
            rahmen = data.map(item => {
                item.key = item.orgUuid;
                item.title = item.name;
                item.value = [item.name,item.orgUuid];
                item.type = item.orgType;
                if (item.children) {
                    return (
                        <TreeNode title={item.title} value={item.value} type={item.type} key={item.key} dataRef={item} >
                            {this.renderTreeNodes(item.children)}
                        </TreeNode>
                    );
                }
                //console.log(data)
                return <TreeNode title={item.title} value={item.value} type={item.type} key={item.key} dataRef={item} />;
            });
            return rahmen;
        }

    }
    handleChange=(value)=>{
        // console.log(value)
        // this.setState({
        //     value
        // },()=>{
        //     console.log(this.state.value)
        // })
    }

    render() {
        const { lessee } = this.state;
        const { editorialContent } = this.props;
        const { getFieldDecorator } = this.props.form;
        //this.graylLevelJudgement(version.scale_content)
        let treeDasta = this.combine(lessee);
        const options = [
            {
                value: '彩管家',
                label: '彩管家',
                children: [
                    {
                        value: 'Android',
                        label: 'Android',
                    },
                    {
                        value: 'ios',
                        label: 'ios',
                    }
                ],
            },
            {
                value: '彩之云',
                label: '彩之云',
                children: [
                    {
                        value: 'Android',
                        label: 'Android',
                    },
                    {
                        value: 'ios',
                        label: 'ios',
                    }
                ],
            },{
                value: '物业通',
                label: '物业通',
                children: [
                    {
                        value: 'Android',
                        label: 'Android',
                    },
                    {
                        value: 'ios',
                        label: 'ios',
                    }
                ],
            },
        ];
        const formItemLayout2 = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
        };
        const tProps = {
            treeData: treeDasta,
            treeCheckable: true,
            showCheckedStrategy: SHOW_PARENT,
            size:"large",
            style: {
                width: 500
            },
            searchPlaceholder: "请选择",
            onChange: this.handleChange,
        }
        const tonalRange=(editorialContent)=>{
            if(this.state.gray == 0 && editorialContent.scale_content &&editorialContent.state!==2){
                return (
                 <div>
                <Form.Item label="手机号" {...formItemLayout2}>
                 {getFieldDecorator('phone', {
                     initialValue: this.phones(this.props.editorialContent.scale_content)
                 })(
                     <Select mode="tags" style={{ width: 500 }} tokenSeparators={[',']}
                         placeholder="请输入手机号，并按Enter键继续"
                         onChange={this.onInputKeyDown}
                         size="large"
                         getPopupContainer={triggerNode => triggerNode.parentNode}
                     >
                     </Select>

                 )}
                 <Button onClick={()=>{this.props.form.setFieldsValue({"phone":[]})}}>清空手机号</Button>
                 {
                     this.state.phoneNumber ? "" :
                         <div style={{ color: 'red', fontSize: '14px' }}>
                             请输入正确的手机号
              </div>
                 }
             </Form.Item>
             <Form.Item label="组织架构" {...formItemLayout2}>
                 {getFieldDecorator('organization', {
                     initialValue: this.organizational(this.props.editorialContent.scale_content)
                 })(
                     <TreeSelect
                        showSearch
                         placeholder='请选择'
                         dropdownStyle={{ height: 300 }}
                         style={{ width: 500 }}
                         loadData={this.onLoadData.bind(this)}
                         treeCheckable
                         onSearch={this.tree_search}
                         getPopupContainer={triggerNode => triggerNode.parentNode}
                         size="large"
                     >
                         {this.renderTreeNodes(this.state.framework)}
                     </TreeSelect>

                 )}
                 <Button onClick={()=>{this.props.form.setFieldsValue({"organization":[]})}}>清空组织架构</Button>
             </Form.Item>
             <FormItem label="租户" {...formItemLayout2} required={false}>
                 {getFieldDecorator('tenant', {
                      initialValue: this.lease(this.props.editorialContent.scale_content)
                 })(
                     <TreeSelect {...tProps} getPopupContainer={triggerNode => triggerNode.parentNode}>
                     </TreeSelect>
                 )}
                 <Button onClick={()=>{this.props.form.setFieldsValue({"tenant":[]})}}>清空租户</Button>
             </FormItem>
                 </div>
                )
            }else if(this.state.gray == 2){
                return(
                    <div>
                    <Form.Item label="手机号" {...formItemLayout2}>
                     {getFieldDecorator('phone', {
                         initialValue: this.phones(this.props.editorialContent.scale_content)
                     })(
                         <Select mode="tags" style={{ width: 500 }} tokenSeparators={[',']}
                             placeholder="请输入手机号，并按Enter键继续"
                             onChange={this.onInputKeyDown}
                             size="large"
                             getPopupContainer={triggerNode => triggerNode.parentNode}
                         >
                         </Select>
    
                     )}
                     <Button onClick={()=>{this.props.form.setFieldsValue({"phone":[]})}}>清空手机号</Button>
                     {
                         this.state.phoneNumber ? "" :
                             <div style={{ color: 'red', fontSize: '14px' }}>
                                 请输入正确的手机号
                  </div>
                     }
                 </Form.Item>
                 <Form.Item label="组织架构" {...formItemLayout2}>
                     {getFieldDecorator('organization', {
                         initialValue: this.organizational(this.props.editorialContent.scale_content)
                     })(
                         <TreeSelect
                            showSearch
                             placeholder='请选择'
                             dropdownStyle={{ height: 300 }}
                             style={{ width: 500 }}
                             loadData={this.onLoadData.bind(this)}
                             treeCheckable
                             onSearch={this.tree_search}
                             getPopupContainer={triggerNode => triggerNode.parentNode}
                             size="large"
                         >
                             {this.renderTreeNodes(this.state.framework)}
                         </TreeSelect>
    
                     )}
                     <Button onClick={()=>{this.props.form.setFieldsValue({"organization":[]})}}>清空组织架构</Button>
                 </Form.Item>
                 <Form.Item label="租户" {...formItemLayout2} required={false}>
                     {getFieldDecorator('tenant', {
                         initialValue: this.lease(this.props.editorialContent.scale_content)
                     })(
                         <TreeSelect {...tProps} getPopupContainer={triggerNode => triggerNode.parentNode}>
                         </TreeSelect>
                     )}
                     <Button onClick={()=>{this.props.form.setFieldsValue({"tenant":[]})}}>清空租户</Button>
                 </Form.Item>
                     </div>
                )
            }
         }
        return (
            <Card
                style={{ width: '100%', marginBottom: 20 }}
            >
                <Form style={{ width: '100%', paddingBottom: 20, marginBottom: 20 }} onSubmit={this.handleSubmit}>
                    <FormItem label="App类型"{...formItemLayout2} >
                        {getFieldDecorator('select', {
                            rules: [{ required: true, message: '请选择App类型!' }],
                            initialValue: this.mold(editorialContent)
                        })(
                            <Cascader
                                setfieldvalue="编辑"
                                changeOnSelect
                                options={options}
                                placeholder="请选择App类型"
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                            ></Cascader>
                        )}

                    </FormItem>
                    <Form.Item label="版本号" {...formItemLayout2}>
                        {getFieldDecorator('input-number', {
                            initialValue: editorialContent.version,
                            rules: [{ required: true, message: '请输入版本号!' }]
                        })
                            (
                                <Input
                                    placeholder="请输入版本号"
                                    onBlur={this.inputOnBlurStaff}
                                >
                                </Input>
                            )}
                        {this.state.versionjudgement ? '' : <div style={{ color: 'red', fontSize: '12px' }}>
                            版本号必须是三位，x.x.x的形式,每位x的范围分别为1-99,0-99,0-99。
                            不允许的情况0.x.x；01.x.x; x.0x.x; x.00.x； x.x.00; x.x.0x
                                </div>}
                    </Form.Item>
                    <Form.Item label="支持最低版本" {...formItemLayout2}>
                        {getFieldDecorator('version-number', {
                            initialValue: editorialContent.min_version,
                            rules: [{ required: true, message: '请输入版本号!' }]
                        })
                            (
                                <Input
                                    placeholder="请输入版本号"
                                    onBlur={this.versionOnBlurStaff} />,
                            )}
                        {this.state.versionjudg ? '' : <div style={{ color: 'red', fontSize: '14px' }}>
                            版本号必须是三位，x.x.x的形式,每位x的范围分别为1-99,0-99,0-99。
                            不允许的情况0.x.x；01.x.x; x.0x.x; x.00.x； x.x.00; x.x.0x
                                                            </div>}
                    </Form.Item>
                    <Form.Item label="修复的BUG" {...formItemLayout2}>
                        {getFieldDecorator('restoredBug', {
                            initialValue: editorialContent.bug,
                            rules: [{ required: true, message: '请输入修复的BUG!' }]
                        })
                            (
                                <TextArea
                                    placeholder="请输入修复的BUG"
                                    autosize={{ minRows: 3, maxRows: 5 }}
                                />
                            )}
                    </Form.Item>
                    <Form.Item label="发布的内容" {...formItemLayout2}>
                        {getFieldDecorator('contents', {
                            initialValue: editorialContent.func,
                            rules: [{ required: true, message: '请输入发布的内容!' }]
                        })
                            (
                                <TextArea
                                    placeholder="发布的内容"
                                    autosize={{ minRows: 3, maxRows: 5 }}
                                />
                            )}
                    </Form.Item>
                    <Form.Item label="灰度范围" {...formItemLayout2} >
                        {getFieldDecorator('tonal_range', {
                            initialValue:editorialContent.state===2?1:editorialContent.scale_content ? 2 : 1,
                            rules: [{ required: true, message: '请选择灰度范围!' }]
                        })(
                            <Radio.Group onChange={this.tonalOnChange}>
                                <Radio value={1} >
                                    全量
                                </Radio>
                                <Radio value={2}>
                                    灰度
                                </Radio>
                            </Radio.Group>
                         )}
                    </Form.Item>
                    {tonalRange(editorialContent)}
                    
                    <Form.Item wrapperCol={{ span: 12, offset: 6 }} style={{ marginTop: 20 }}>
                        <Button type="primary" htmlType="submit">
                            确认
                       </Button>
                    </Form.Item>
                </Form>
            </Card>
        )
    }
}

const OrderEditVersionl = Form.create()(EditVersion);
export default OrderEditVersionl;